import script from "./whiteList.vue?vue&type=script&setup=true&lang=js"
export * from "./whiteList.vue?vue&type=script&setup=true&lang=js"

import "./whiteList.vue?vue&type=style&index=0&id=c4307e1e&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4307e1e"]])

export default __exports__